<template>
  <v-dialog v-model="dialog" persistent max-width="500px" @keydown.esc="close">
    <v-card>
      <div class="add_fa" style="height: 280px">
        <button class="close_bt" @click="closeDialog"></button>
        <div class="download-btn" @click="downloadMenual('manual1')">
          사용자 매뉴얼
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
import debounce from 'lodash.debounce';
import excel from 'exceljs';

export default {
  components: {},
  props: ['dialog', 'closeDialog'],
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  methods: {
    downloadMenual(num) {
      let file_path = '';
      switch (num) {
        case 'manual1':
          file_path = '/static/ksd/KSD-(DWS)-DP-01(사용자메뉴얼-스마트회의)-v0.97.pptx';
          break;
      }

      let a = document.createElement('A');
      a.href = file_path;
      a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>
<style scoped>
.download-btn {
  display: inline-block;
  border: none;
  border-radius: 5px;
  background: #1457aa;
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 500;
  font-size: 16pt;
  color: #fff;
  width: 150px;
  height: 100px;
  cursor: pointer;
  line-height: 100px;
  margin: 0 10px;
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ManualDialog.vue